import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import moment from "moment"

moment.locale("es")

// Globals styles
import "./assets/css/main.css";

import './registerServiceWorker'

// Plugins
require("./plugins");

// Detects if device is on iOS 
const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test( userAgent );
}

if(!isIos()){
  Notification.requestPermission(function(status) {
    // console.log('Notification permission status:', status);
  });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");
